import { createJsonQuery } from '@farfetched/core'
import { runtypeContract } from '@farfetched/runtypes'
import { Array } from 'runtypes'
import { allCitiesUrl } from '@entities/cities/api'
import { City, ICity } from './contract'

export const citiesQuery = createJsonQuery({
    request: {
        method: 'GET',
        url: () => allCitiesUrl()
    },
    initialData: [] as ICity[],
    serialize: 'ignore',
    response: {
        contract: runtypeContract(Array(City))
    }
})

export const $cities = citiesQuery.$data
